import { ReduxStore } from "../../reducers/root_reducer";

const getRunningProcesses = (state: ReduxStore, props) => state.runningProcesses;

export default getRunningProcesses;
